import cn from 'classnames';
import React from 'react';

import styles from './WatchlistNotification.css';
import {
    useWatchlistNotificationState,
    useWatchlistNotificationTrigger
} from './watchlistnotification-context';
import { useWatchlistState } from '../../Hooks/useWatchlist';

import ArrowRight from '../../images/chevron-right-blue.svg';
import CrossIcon from '../../images/cross-icon.svg';
import SuccessIcon from '../../images/Green-check.svg';

const WatchlistNotification = () => {
    const isOnWatchlistPage = window.location.pathname.includes('watchlist');
    const isOnComparePage = window.location.pathname.includes('compare');
    const { pushWatchlistNotification } = useWatchlistState();
    const {
        display: showNotification,
        watchlistName,
        addingFundMsg,
        addingNewWatchlist,
        amountOfFundsAdded
    } = useWatchlistNotificationState();
    const triggerWatchlistNotification = useWatchlistNotificationTrigger();
    const dismissWatchlistNotification = () =>
        triggerWatchlistNotification({
            display: false
        });
    const mainAddMsg = isOnComparePage
        ? `Fund Added to `
        : `Added ${amountOfFundsAdded} Fund(s) to `;
    return (
        <div
            data-metrics-location="PU"
            className={cn('toast-container', {
                show: showNotification,
                hidden: !showNotification,
                'push-up': pushWatchlistNotification
            })}
        >
            <img alt="" src={SuccessIcon} />
            <div className="toast-text">
                {isOnWatchlistPage ? (
                    <div>
                        {addingNewWatchlist ? watchlistName : 'Fund'}{' '}
                        {addingFundMsg ? 'Added' : 'Removed'}
                    </div>
                ) : (
                    <div>
                        {addingFundMsg ? mainAddMsg : 'Removed from '}
                        <a className="link" href="/usis/research/watchlist">
                            Watchlists
                        </a>
                    </div>
                )}
            </div>
            {isOnWatchlistPage ? (
                <input
                    id="dismiss-watchlist-notification-input"
                    alt=""
                    className="right-icon"
                    onClick={() =>
                        dismissWatchlistNotification({ display: false })
                    }
                    onKeyPress={() =>
                        dismissWatchlistNotification({ display: false })
                    }
                    tabIndex={0}
                    type="image"
                    src={CrossIcon}
                />
            ) : (
                <img alt="" className="right-icon" src={ArrowRight} />
            )}
            <style jsx>{styles}</style>
        </div>
    );
};

export default WatchlistNotification;
